import { AnalyticsPageFilters } from '.';

const AnalyticsSuperadmin = () => {
  return (
    <div>
      <AnalyticsPageFilters />
    </div>
  );
};

export default AnalyticsSuperadmin;
